var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgYoutubeLogo1 = function SvgYoutubeLogo1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 15,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F03",
    fillRule: "evenodd",
    d: "M17.792.453c.86.248 1.54.976 1.771 1.896C19.988 4.025 20 7.5 20 7.5s0 3.489-.424 5.151c-.23.92-.911 1.648-1.771 1.896C16.252 15 10 15 10 15s-6.252 0-7.805-.453c-.86-.248-1.54-.976-1.771-1.896C0 10.975 0 7.5 0 7.5s0-3.475.41-5.137c.232-.92.912-1.649 1.772-1.896C3.736.014 9.987 0 9.987 0s6.252 0 7.805.453M13.184 7.5l-5.187 3.214V4.286z",
    clipRule: "evenodd"
  })));
};
export default SvgYoutubeLogo1;